import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { eventsApi } from "@/lib/humhub-api/events";
import type { EventCreateApiRequest } from "@/lib/humhub-api/types";
import { queryInvalidationHelpers } from "@/lib/queryInvalidationHelpers";

export const useCreateEvent = () => {
  const queryClient = useQueryClient();

  // React Queryのミューテーションでイベント作成処理
  const mutation = useMutation({
    mutationFn: async ({
      containerId,
      event,
      files,
    }: {
      containerId: number;
      event: EventCreateApiRequest;
      files: File[];
    }) => {
      return eventsApi.createEvent(containerId, event, files);
    },
    onSuccess: (_, variables) => {
      queryInvalidationHelpers.invalidateEventQueries(queryClient, {
        containerId: variables.containerId,
      });
    },
    onError: (error) => {
      console.error("Error creating event:", error);
    },
  });

  const createEvent = useCallback(
    async (
      containerId: number,
      event: EventCreateApiRequest,
      files: File[],
    ) => {
      return mutation.mutateAsync({ containerId, event, files });
    },
    [mutation],
  );

  const reset = useCallback(() => {
    mutation.reset();
  }, [mutation]);

  return {
    createEvent,
    createdData: mutation.data || null,
    isLoading: mutation.isPending,
    error: mutation.error ? String(mutation.error) : null,
    isSuccess: mutation.isSuccess,
    reset,
  };
};
